__turbopack_context__.v({
  "cta": "GenerateButton-module-scss-module__kZb2Za__cta",
  "ctaActive": "GenerateButton-module-scss-module__kZb2Za__ctaActive",
  "ctaDisabled": "GenerateButton-module-scss-module__kZb2Za__ctaDisabled",
  "enter": "GenerateButton-module-scss-module__kZb2Za__enter",
  "exit": "GenerateButton-module-scss-module__kZb2Za__exit",
  "fade-in": "GenerateButton-module-scss-module__kZb2Za__fade-in",
  "fade-out": "GenerateButton-module-scss-module__kZb2Za__fade-out",
  "fade-out-80": "GenerateButton-module-scss-module__kZb2Za__fade-out-80",
  "generate-spinner-rotate": "GenerateButton-module-scss-module__kZb2Za__generate-spinner-rotate",
  "label": "GenerateButton-module-scss-module__kZb2Za__label",
  "slide-in-from-bottom": "GenerateButton-module-scss-module__kZb2Za__slide-in-from-bottom",
  "slide-in-from-left": "GenerateButton-module-scss-module__kZb2Za__slide-in-from-left",
  "slide-in-from-right": "GenerateButton-module-scss-module__kZb2Za__slide-in-from-right",
  "slide-in-from-top": "GenerateButton-module-scss-module__kZb2Za__slide-in-from-top",
  "slide-out-to-bottom": "GenerateButton-module-scss-module__kZb2Za__slide-out-to-bottom",
  "slide-out-to-left": "GenerateButton-module-scss-module__kZb2Za__slide-out-to-left",
  "slide-out-to-right": "GenerateButton-module-scss-module__kZb2Za__slide-out-to-right",
  "slide-out-to-top": "GenerateButton-module-scss-module__kZb2Za__slide-out-to-top",
  "spinner": "GenerateButton-module-scss-module__kZb2Za__spinner",
  "spinnerLabel": "GenerateButton-module-scss-module__kZb2Za__spinnerLabel",
  "spinnerWrap": "GenerateButton-module-scss-module__kZb2Za__spinnerWrap",
  "zoom-in": "GenerateButton-module-scss-module__kZb2Za__zoom-in",
  "zoom-out": "GenerateButton-module-scss-module__kZb2Za__zoom-out",
});
